let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("1xmlT")]).then(() => parcelRequire('eJKC4'));